import { TimesheetReportTable } from './timesheet-report-table'

export const TimesheetReportsPageV2 = () => {
    return <TimesheetReportTable />
}
